import { Box, BoxProps } from '@chakra-ui/react'
import * as React from 'react'

import { TextBody, TextBodyBold2, TextSubtitle } from '../common/Text'
import { vw } from '../../styles/theme'

export type TopCovid19Props = BoxProps & {}

const TopCovid19: React.FC<TopCovid19Props> = ({ ...others }) => {
  return (
    <>
      <Box pt={[vw(150), '100px']} pb={[vw(150), '150px']} bg="background.gray" {...others}>
        <Box w={['contentSP', '660px']} m="0 auto" textAlign={['center', 'left']}>
          <Box mb={[vw(60), '30px']}>
            <TextSubtitle localizeKey="top__covid19__title" />
            <TextBodyBold2 localizeKey={'top__covid19__title_annotation'} />
          </Box>
          <Box mb={[vw(60), '50px']}>
            <TextBodyBold2 localizeKey={'top__covid19__title_en'} color="text.100" />
          </Box>
          <Box textAlign="left">
            <TextBody localizeKey={'top__covid19__body'} />
          </Box>
        </Box>
      </Box>
    </>
  )
}

export default TopCovid19
